// Información de la tienda - Constante global
export const STORE_INFO = {
  name: 'JOYERÍA BRILLANTE',
  address: 'Av. Principal 123',
  city: 'La Paz, Bolivia',
  phone: '+591 2 123-4567',
  nit: '1234567890',
  website: 'www.joyeriabrillante.com',
  socialMedia: 'Síguenos en redes sociales',
} as const;
